import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { fuseAnimations } from '../../../../core/animations';
import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { VouchersComponentService } from './vouchers.component.service';
import { MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
import { FuseUtils } from '../../../../core/fuseUtils';
import { VoucherFormDialogComponent } from './voucher-form/voucher-form.component';
import { FormGroup } from '@angular/forms';
import { VoutchersService } from '../../../../core/services/vouchers/vouchers.service';
import { Voucher } from '../../../../core/services/vouchers/voucher.model';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.scss'],
  animations : fuseAnimations
})
export class VouchersComponent implements OnInit {
    dataSource: FilesDataSource | null;
    displayedColumns = ['code', 'onetime', 'expiration', 'method', 'value', 'disabled'];

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;

    pageNumber = 0;
    pageLength = 0;
    dialogRef: any;

    constructor(
        private readonly vouchersComponentService: VouchersComponentService,
        private readonly vouchersService: VoutchersService,
        private readonly dialog: MatDialog,
        private readonly snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.dataSource = new FilesDataSource(this.vouchersComponentService, this.paginator, this.sort);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
                  .debounceTime(150)
                  .distinctUntilChanged()
                  .subscribe(() => {
                      if ( !this.dataSource )
                      {
                          return;
                      }
                      this.dataSource.filter = this.filter.nativeElement.value;
                  });

        this.pageNumber = Number.parseInt(localStorage.getItem('vouchersPageNumber'));
        this.pageLength = Number.parseInt(localStorage.getItem('vouchersPageLength'));
    }

    storePaginatorState() {
        localStorage.setItem('vouchersPageNumber', this.paginator.pageIndex.toString());
        localStorage.setItem('vouchersPageLength', this.paginator.pageSize.toString());
    }

    addVoucher(): void {
        this.dialogRef = this.dialog.open(VoucherFormDialogComponent, {
            panelClass: 'voucher-form-dialog',
            data      : {
                action: 'new'
            }
        });
        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if ( !response )
                {
                    return;
                }
                const newVoucher = response.getRawValue();
                // console.log(newVoucher);
                this.vouchersService.create(newVoucher).subscribe((data) => {
                    this.snackBar.open('Bon de réduction créé avec succès.', null, {
                        verticalPosition: 'bottom',
                        duration        : 2000
                    });
                    this.vouchersComponentService.getVouchers();
                }, (err) => {
                    this.snackBar.open('Une erreur est survenue, veuillez vérifier que ce code n\'est pas existant.', null, {
                        verticalPosition: 'bottom',
                        duration        : 8000
                    });
                });
            });
    }

    editVoucher(action: string, voucher: Voucher)
    {
        this.dialogRef = this.dialog.open(VoucherFormDialogComponent, {
            panelClass: 'voucher-form-dialog',
            data      : {
                voucher : voucher,
                action: action
            }
        });

        this.dialogRef.afterClosed()
            .subscribe(response => {
                if ( !response )
                {
                    return;
                }
                const actionType: string = response[0];
                const formData: FormGroup = response[1];
                switch ( actionType )
                {
                    case 'save':
                        const voucher = formData.getRawValue();
                        // console.log(voucher);
                        this.vouchersService.update(voucher).subscribe((data) => {
                            this.snackBar.open('Bon de réduction enregistré avec succès.', null, {
                                verticalPosition: 'top',
                                duration        : 2000
                            });
                            this.vouchersComponentService.getVouchers();
                        }, (err) => {
                            this.snackBar.open('Une erreur est survenue, veuillez réessayer ultérieurement.', null, {
                                verticalPosition: 'bottom',
                                duration        : 8000
                            });
                        });
                        break;
                    // case 'delete':
                    //     this.removeTicket(ticket);
                    //     break;
                }
            });
    }

}

export class FilesDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any
    {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any)
    {
        this._filteredDataChange.next(value);
    }

    get filter(): string
    {
        return this._filterChange.value;
    }

    set filter(filter: string)
    {
        this._filterChange.next(filter);
    }

    constructor(
        private readonly vouchersComponentService: VouchersComponentService,
        private _paginator: MatPaginator,
        private _sort: MatSort
    )
    {
        super();
        this.filteredData = this.vouchersComponentService.vouchers;
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]>
    {
        const displayDataChanges = [
            this.vouchersComponentService.onVouchersChanged,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.vouchersComponentService.vouchers.slice();
            data = this.filterData(data);
            this.filteredData = [...data];
            data = this.sortData(data);
            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });
    }

    filterData(data)
    {
        if ( !this.filter )
        {
            return data;
        }
        return FuseUtils.filterArrayByString(data, this.filter);
    }

    sortData(data): any[]
    {
        if ( !this._sort.active || this._sort.direction === '' )
        {
            return data;
        }

        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';

            switch ( this._sort.active )
            {
            //     case '_id':
            //         [propertyA, propertyB] = [a.id, b.id];
            //         break;
            //     case 'title':
            //         [propertyA, propertyB] = [a.name, b.name];
            //         break;
            //     // case 'parentCategory':
            //     //     [propertyA, propertyB] = [a.parentCategory.title, b.parentCategory.title];
            //     //     break;
            //     case 'category':
            //         [propertyA, propertyB] = [a.category.title, b.category.title];
            //         break;
            //     case 'quantity':
            //         [propertyA, propertyB] = [a.quantity, b.quantity];
            //         break;
            //     case 'disabled':
            //         [propertyA, propertyB] = [a.active, b.active];
            //         break;
                case 'value':
                    [propertyA, propertyB] = [a.value, b.value];
                    break;
                case 'expiration':
                    const d1 = new Date(a.expiration).getTime();
                    const d2 = new Date(b.expiration).getTime();
                    [propertyA, propertyB] = [d1, d2];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    disconnect()
    {
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/vouchers/vouchers.component.ts